import React, { useState } from 'react';
import { TextField, Typography, Select, FormControl, MenuItem, InputLabel, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import mpcst from '../Image/newmpcst-logo.jpg';
import logo from '../Image/logo.png';

import { useLanguage } from '../context/LanguageContext';
import { useMode } from "../context/modeContext";

import { auth } from "../auth/config";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { setConfirmationResultStore } from "../auth/store";

const Mobileno = () => {

  const [loading, setLoading] = useState(false);   
  const [phone, setPhone] = useState("");

  const { language, setLanguage, t } = useLanguage();
  const { mode } = useMode();

  const navigate = useNavigate();

  const handleLanguageChange = (event) => {
    setLanguage(event.target.value);
  };

  const sendOTP = async () => {

    setLoading(true); // start loading

    if (phone.length !== 10) {
      alert("Enter a valid 10-digit phone number");
      setLoading(false);
      return;
    }

    if (window.recaptchaVerifier) {
      window.recaptchaVerifier.clear();
    }

    window.recaptchaVerifier = new RecaptchaVerifier(
      auth,
      "recaptcha-container",
      { size: "invisible" }
    );

    try {

      const confirmationResult = await signInWithPhoneNumber(
        auth,
        `+91${phone}`,
        window.recaptchaVerifier
      );

      setConfirmationResultStore(confirmationResult);

      navigate("/secondscreen", {
        state: { number: phone }
      });

    } catch (err) {

      console.error(err);
      alert("Failed to send OTP. Try again.");
      setLoading(false);

    }

  };

  return (
    <>
      <div className='doctorapp-Wrapper'>

        <div className='firstScreen'>

          <div className='leftSide'>

            <div className='language-box'>
              <FormControl fullWidth>
                <InputLabel>{t('language_label')}</InputLabel>

                <Select
                  value={language}
                  label={t('language_label')}
                  onChange={handleLanguageChange}
                >
                  <MenuItem value="en">English</MenuItem>
                  <MenuItem value="hi">Hindi</MenuItem>
                </Select>

              </FormControl>
            </div>

            <div>
              <Typography variant='h2'>{t('get_started')}</Typography>
            </div>

            <form>

              <div className='subTitle'>
                <Typography variant='h4'>{t('enter_phone')}</Typography>
              </div>

              <div className='mobile-field'>

                <div className='mob-filed'>
                  <TextField
                    disabled
                    sx={{ width: '80px' }}
                    label='+91'
                    variant='outlined'
                    size='medium'
                  />
                </div>

                <div className='textFiled'>

                  <TextField
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    label={t('mobile_label')}
                    type='tel'
                    variant='outlined'
                    size='medium'
                    fullWidth
                    required
                  />

                </div>

              </div>

              <div id="recaptcha-container"></div>

              <div className='custom-btn'>

                <Button
                  type="button"
                  onClick={sendOTP}
                  variant="contained"
                  sx={{ mt: 3 }}
                  disabled={loading}
                >
                  {loading ? "Loading..." : t('continue_btn')}
                </Button>

              </div>

            </form>

          </div>

        </div>

      </div>
    </>
  );
};

export default Mobileno;